let preventAppUnloadForMail = false;

export const getPreventAppUnload = () => {
    return preventAppUnloadForMail;
};

export const setPreventAppUnload = (value) => {
    preventAppUnloadForMail = value;
};
